export default {
  name: "tableMixins",
  data() {
    return {
      tablePagination: {
        page: 1,
        size: 20,
        total: 0,
      },
      pageSizeList: [20, 50, 100, 200],
      tableLoading: false,
      tableData: [],
      selectRows: [], //选中
    };
  },
  methods: {
    handleSizeChange(val) {
      this.tablePagination.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.tablePagination.page = val;
      this.getList();
    },
    handleSelectionChange(rows) {
      this.selectRows = rows;
    },
    clearSelection() {
      this.$refs.tableList && this.$refs.tableList.clearSelection(); //清空选中数据
    },
  },
};
